module.exports = __webpack_public_path__ + "img/img41.7a245309.jpg";